import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import Actions_Wind from '~/Actions_Wind';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import PageTitle from '~/components/PageTitle';
import { S_Btn_Search, S_DateInput, S_LimitDateInput, S_Title, S_Select } from '~/components/SearchItem';
import Single from './Single';

const timeUnitList = [
  { name: '週(Week)', value: 'week' },
  { name: '月(Month)', value: 'month' },
];

const getFirstDay = (unit, customDate = null) => {
  const date = (customDate)? customDate : new Date(2023, 0);
  if (unit == 'week') {
    date.setDate(date.getDate() - date.getDay());
  } else if (unit == 'month') {
    date.setDate(1);
  }
  return date;
};

const getLastDay = (unit, customDate = null) => {
  const date = (customDate)? customDate : new Date();
  if (unit == 'week') {
    date.setDate(date.getDate() - date.getDay() + 6);
  } else if (unit == 'month') {
    date.setMonth(date.getMonth() + 1);
    date.setDate(0);
  }
  return date;
};


const App = (props) => {
  const [data, setData] = useState({ time_unit: 'week', start_date: getFirstDay('week'), end_date: getLastDay('week') });
  const [list, setList] = useState([]);
  const { time_unit, start_date, end_date } = data;
  const [searchTime, setSearchTime ] = useState({
    startDate: moment(start_date).format('YYYY/MM/DD'),
    endDate: moment(end_date).format('YYYY/MM/DD'),
    timeUnit: 'week'
  });
  const dispatch = useDispatch();
  const reportDataList = useSelector(state => state.data.GisStepReportDataV2R2 || []);
  const onClickSearch = () => {
    let adjustedStartDate = start_date;
    let adjustedEndDate = end_date;
  
    if (time_unit === 'week') {
      if (isSunday(start_date) && isSaturday(end_date)) {
        // do nothing
      } else {
        adjustedStartDate = getFirstDay('week', start_date);
        adjustedEndDate = getLastDay('week', end_date);
      }
    } else if (time_unit === 'month') {
      if (isFirstDayOfMonth(start_date) && isLastDayOfMonth(end_date)) {
        // do nothing
      } else {
        adjustedStartDate = getFirstDay('month', start_date);
        adjustedEndDate = getLastDay('month', end_date);
      }
    }
  
    Actions_Wind_V2.Gis.getGisStepReportDataV2R2(dispatch, { start_date: moment(adjustedStartDate).format('YYYY-M-D'), end_date: moment(adjustedEndDate).format('YYYY-M-D'), time_unit });
    setSearchTime({
      startDate: moment(adjustedStartDate).format('YYYY/MM/DD'),
      endDate: moment(adjustedEndDate).format('YYYY/MM/DD'),
      timeUnit: time_unit
    });
  };
  
  useEffect(onClickSearch, []);
  
  useEffect(() => () => Actions_Wind_V2.clearKey(dispatch, { key: 'GisStepReportDataV2R2' }), []);
  
  useEffect(() => {
    if (reportDataList.length > 0) {
      const mock_data = {
        list: [
          {
              multiple: false,
              dataAry: ["2", "3", "3", "4", "3", "5"],
              project: "水下基礎_基樁",
          },
          {
              multiple: false,
              dataAry: ["1", "3", "2", "5", "3", "8"],
              project: "水下基礎_套筒(含TP段)",
          },
          {
              multiple: true,
              data: [
                  {
                      order: 0,
                      dataAry: ["1", "3", "3", "5", "8", "9"],
                      project: "風力機_塔架",
                      rowSpan: [{ index: 4, span: 3 }, { index: 5, span: 3 }],
                  },
                  {
                      order: 1,
                      dataAry: ["3", "5", "2", "8"],
                      project: "風力機_機艙",
                  },
                  {
                      order: 2,
                      dataAry: ["1", "5", "16", "23"],
                      project: "風力機_葉片",
                  },
              ],
          },
        ],
        wind_name: '人生如戲_戲如人生',
      };

      // console.log([mock_data, ...reportDataList ]);
      // setList([mock_data, ...reportDataList ]);
    }
    console.log(reportDataList);
    setList(reportDataList);
  }, [reportDataList]);

  useEffect(() => {
    console.log('time_unit', time_unit);
    setData({ ...data, start_date: getFirstDay(time_unit, data.start_date), end_date: getLastDay(time_unit, data.end_date) })
  }, [time_unit]);

  const isSaturday = (date) => {
    return !(date.getDay() === 6);
  }

  const isSunday = (date) => {
    return !(date.getDay() === 0);
  }

  const isFirstDayOfMonth = (date) => {
    const selectedDate = new Date(date);
    const firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
    return selectedDate.getTime() !== firstDayOfMonth.getTime();
  }
  
  const isLastDayOfMonth = (date) => {
    const selectedDate = new Date(date);
    const lastDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
    return selectedDate.getTime() !== lastDayOfMonth.getTime();
  }

  const startLimitFunction = time_unit === 'week' ? isSunday : isFirstDayOfMonth;
  const endLimitFunction = time_unit === 'week' ? isSaturday : isLastDayOfMonth;
  
  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}>
      <PageTitle text='各項目階段工進期間&累計報表' />

      <div style={{ marginTop: 24, display: 'flex' }}>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='時間單位 (Time Unit)' />
          <S_Select list={timeUnitList} value={time_unit} onChange={t => setData({ ...data, time_unit: t })} />
        </div>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='日期區間 (Time Period)' />
          <S_LimitDateInput value={start_date} limit={startLimitFunction} onChange={t => setData({ ...data, start_date: t })} />
        </div>
        <div style={{ marginLeft: 16, paddingTop: 24 }}>
          <S_LimitDateInput value={end_date} limit={endLimitFunction} onChange={t => setData({ ...data, end_date: t })} />
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={onClickSearch} />
        </div>
      </div>

      {list.map((o, i) => <Single key={i} data={o} searchTime={searchTime} />)}

    </div>
  );
};

export default App;
